import { readIsClinicAdmin } from "~/services/readIsClinicAdmin";

export default async function ({ store, redirect, route, app }) {
  if (store.getters["auth/isLoggedIn"]) {
    const isAdmin = await readIsClinicAdmin(store.getters["auth/getUserId"]);
    if (isAdmin) {
      alert(app.i18n.t("middleware.pleaseUsePatientAccount"));
      await store.dispatch("auth/logout");
      redirect({
        path: app.localePath("/appointment/login"),
        query: { from: route.path },
      });
    }
  }
}
